// extracted by mini-css-extract-plugin
export default {"wrapper":"error_wrapper__Id1mE","title":"error_title__R0na-","sub_title":"error_sub_title__z1LUx"};